// extracted by mini-css-extract-plugin
export default {"content":"not-found_content__EfNXN","notFound":"not-found_notFound__J5+xn"};